// src/components/auth/VerificationPending.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const VerificationPending = () => {
  const location = useLocation();
  const email = location.state?.email || '';
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Provjerite vaš email da verifikujete račun</h2>
        </div>
        
        <div className="verification-pending-content">
          <div className="success-message">
            <div className="success-icon">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#4CAF50" strokeWidth="2"/>
                <path d="m9 12 2 2 4-4" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Registracija uspješna!</h3>
            <p>
              Poslali smo verifikacijski email na adresu:
              {email && <strong> {email}</strong>}
            </p>
          </div>
          
          <div className="verification-instructions">
            <h4>Šta je sledeće?</h4>
            <ol>
              <li>Provjerite vaš email sandučić (uključujući spam folder)</li>
              <li>Kliknite na verifikacijski link u email-u</li>
              <li>Vratite se ovdje da se prijavite na vaš račun</li>
            </ol>
          </div>
          
          <div className="verification-help">
            <p><strong>Niste dobili email?</strong></p>
            <ul>
              <li>Provjerite spam/junk folder</li>
              <li>Sačekajte nekoliko minuta - ponekad kašni</li>
              <li>Kontaktirajte podršku ako email ne stigne za 15 minuta</li>
            </ul>
          </div>
          
          <div className="verification-actions">
            <Link to="/app/login" className="auth-button">
              Idi na prijavu
            </Link>
            
            <div className="contact-support">
              <p>
                Imate problema? 
                <a href="mailto:verify@poreznik.ai?subject=Problem%20sa%20verifikacijom">
                  Kontaktirajte podršku
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationPending; 